/**
 * Transparent Header Controller — v3 (Sticky-Safe, Position-Conflict Fixed)
 * Nirob Khan — dislej.com custom build
 *
 * BUG FIX (v2 → v3):
 * v2-e amra .shopify-section wrapper-e (jeta Dawn-er native .section-header
 * class-o bohon kore, and jar upor CSS-e "position: sticky" deya ache)
 * JS diye "position: relative" inline set korchilam z-index kaj korano-r jonno.
 *
 * Kintu INLINE style external stylesheet-ke override kore — tai amader
 * "position: relative" Dawn-er "position: sticky" rule-ke kill kore dicchilo.
 *
 * Ei bug Theme Editor customizer-e dhora pore nai karon Shopify Section
 * Rendering API (AJAX section reload) diye inject kora <script src> tag
 * browser automatically re-execute kore na — tai customizer preview-e
 * eita kokhono run-i hoy nai. Kintu SAVE-er por real full page load-e
 * script execute hoy, and bug shamne ashe.
 *
 * FIX: position kokhono touch kora hobe na — Dawn-er native "position: sticky"
 * already positioned element hisebe treat hoy, tai shudhu z-index diyei
 * stacking order thik kora jay, kono conflict chara.
 */
class TransparentHeader {
  constructor(header) {
    this.header = header;
    this.sectionWrapper = header.closest('.shopify-section') || header.parentElement;
    this.threshold = parseInt(header.dataset.scrollThreshold, 10) || 100;
    this.defaultScheme = header.dataset.defaultScheme;
    this.transparentScheme = header.dataset.transparentScheme;
    this.ticking = false;
    this.isScrolled = null;

    this.onScroll = this.onScroll.bind(this);
    this.applyOverlap = this.applyOverlap.bind(this);

    window.addEventListener('resize', this.applyOverlap, { passive: true });
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('load', this.applyOverlap);

    // Theme Editor-e section re-render (AJAX) hole eita abar trigger hobe,
    // jate customizer-e o feature thik kaj kore — robustness fix
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this.header)) {
        this.applyOverlap();
        this.onScroll();
      }
    });

    this.applyOverlap();
    this.onScroll();
  }

  /**
   * Header-er actual height measure kore niche-r section-ke negative
   * margin diye upore tene ani. Z-INDEX ONLY — kono position property
   * touch kora hoy na, jate Dawn-er native "position: sticky" rule
   * ovveride na hoy.
   */
  applyOverlap() {
    const headerHeight = this.header.offsetHeight;
    const nextSection = this.sectionWrapper.nextElementSibling;

    if (nextSection) {
      nextSection.style.marginTop = `-${headerHeight}px`;
    }

    // ✅ FIX: position property SET KORA HOY NA.
    // .section-header already "position: sticky" (Dawn native CSS) —
    // sticky/relative/absolute/fixed shob-i "positioned element", tai
    // z-index directly kaj korbe kono conflict chara.
    this.sectionWrapper.style.zIndex = '15';
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    requestAnimationFrame(() => {
      const scrolled = window.scrollY > this.threshold;

      if (scrolled !== this.isScrolled) {
        this.isScrolled = scrolled;

        if (scrolled) {
          this.header.classList.add('is-scrolled');
          this.header.classList.remove(this.transparentScheme);
          this.header.classList.add(this.defaultScheme);
        } else {
          this.header.classList.remove('is-scrolled', this.defaultScheme);
          this.header.classList.add(this.transparentScheme);
        }
      }

      this.ticking = false;
    });
  }
}

function initTransparentHeaders() {
  document.querySelectorAll('.header-wrapper[data-transparent-header="true"]').forEach((header) => {
    // Same header-e duibar initialize hole prevent koro (section re-render-e)
    if (header.dataset.transparentInitialized) return;
    header.dataset.transparentInitialized = 'true';
    new TransparentHeader(header);
  });
}

document.addEventListener('DOMContentLoaded', initTransparentHeaders);
// Theme Editor-e section change/reload holeo re-check koro
document.addEventListener('shopify:section:load', initTransparentHeaders);